import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Transition as _Transition, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b43af13"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "wrap subnav-bar" }
const _hoisted_3 = {
  href: "#top",
  class: "subnav-logo"
}
const _hoisted_4 = { class: "subnav-links" }
const _hoisted_5 = { href: "#story" }
const _hoisted_6 = { href: "#capabilities" }
const _hoisted_7 = { href: "#yours" }
const _hoisted_8 = { href: "#security" }
const _hoisted_9 = { class: "wrap center" }
const _hoisted_10 = { class: "eyebrow teal" }
const _hoisted_11 = { class: "hero-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  class: "rise-word grad",
  style: {"animation-delay":"0.5s"}
}
const _hoisted_14 = { class: "hero-lede" }
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = {
  href: "#story",
  class: "btn btn-ghost"
}
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = {
  "font-family": "JetBrains Mono",
  "font-size": "12",
  fill: "#9BB4CB"
}
const _hoisted_19 = {
  x: "20",
  y: "24"
}
const _hoisted_20 = {
  x: "500",
  y: "24",
  "text-anchor": "middle"
}
const _hoisted_21 = {
  x: "980",
  y: "24",
  "text-anchor": "end"
}
const _hoisted_22 = {
  "font-family": "Plus Jakarta Sans",
  "font-size": "14",
  "font-weight": "700",
  fill: "#E8F3FF"
}
const _hoisted_23 = ["y"]
const _hoisted_24 = ["y"]
const _hoisted_25 = {
  stroke: "#34B1B9",
  "stroke-width": "1.6",
  fill: "none"
}
const _hoisted_26 = ["d"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "ping",
  cx: "500",
  cy: "190",
  r: "70",
  fill: "none",
  stroke: "#34B1B9",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { class: "core" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "500",
    cy: "190",
    r: "74",
    fill: "#0B2733",
    stroke: "#34B1B9",
    "stroke-width": "2"
  })
], -1))
const _hoisted_29 = {
  x: "500",
  y: "184",
  "text-anchor": "middle",
  "font-family": "Plus Jakarta Sans",
  "font-size": "18",
  "font-weight": "800",
  fill: "#E8F3FF"
}
const _hoisted_30 = {
  x: "500",
  y: "206",
  "text-anchor": "middle",
  "font-family": "JetBrains Mono",
  "font-size": "11",
  fill: "#7FD6DC"
}
const _hoisted_31 = {
  stroke: "#34B1B9",
  "stroke-width": "1.6",
  fill: "none"
}
const _hoisted_32 = ["d"]
const _hoisted_33 = {
  "font-family": "Plus Jakarta Sans",
  "font-size": "14",
  "font-weight": "700",
  fill: "#E8F3FF"
}
const _hoisted_34 = ["y"]
const _hoisted_35 = ["y"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "flowline draw",
  d: "M500 264 V318",
  stroke: "#F0B25A",
  "stroke-width": "1.6",
  fill: "none"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "390",
  y: "318",
  width: "220",
  height: "60",
  rx: "16",
  fill: "#1E1A10",
  stroke: "#F0B25A"
}, null, -1))
const _hoisted_38 = {
  x: "500",
  y: "344",
  "text-anchor": "middle",
  "font-family": "Plus Jakarta Sans",
  "font-size": "14",
  "font-weight": "800",
  fill: "#F0B25A"
}
const _hoisted_39 = {
  x: "500",
  y: "364",
  "text-anchor": "middle",
  "font-family": "JetBrains Mono",
  "font-size": "11",
  fill: "#E8D3B0"
}
const _hoisted_40 = { class: "built-on" }
const _hoisted_41 = { class: "wrap" }
const _hoisted_42 = { class: "hl" }
const _hoisted_43 = { class: "wrap story-grid" }
const _hoisted_44 = { class: "eyebrow teal" }
const _hoisted_45 = { class: "story-title" }
const _hoisted_46 = { class: "stage-list" }
const _hoisted_47 = {
  class: "stage-rail",
  "aria-hidden": "true"
}
const _hoisted_48 = ["aria-current", "onClick"]
const _hoisted_49 = { class: "stage-num" }
const _hoisted_50 = { class: "events-label" }
const _hoisted_51 = { class: "event-text" }
const _hoisted_52 = { class: "event-sys" }
const _hoisted_53 = {
  id: "capabilities",
  class: "caps light"
}
const _hoisted_54 = { class: "wrap" }
const _hoisted_55 = { class: "eyebrow ink" }
const _hoisted_56 = { class: "h2" }
const _hoisted_57 = { class: "cap cap-wide cap-dark" }
const _hoisted_58 = {
  class: "cap-visual tools",
  "aria-hidden": "true"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "getContract ✓", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "searchOrders ✓", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "createTicket ✓", -1))
const _hoisted_62 = { class: "amber" }
const _hoisted_63 = { class: "cap" }
const _hoisted_64 = {
  class: "cap-visual playbook",
  "aria-hidden": "true"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = { class: "cap" }
const _hoisted_69 = {
  class: "cap-visual approval",
  "aria-hidden": "true"
}
const _hoisted_70 = { class: "cap" }
const _hoisted_71 = {
  class: "cap-visual sources",
  "aria-hidden": "true"
}
const _hoisted_72 = { class: "cap cap-wide cap-grad" }
const _hoisted_73 = {
  class: "cap-visual results",
  "aria-hidden": "true"
}
const _hoisted_74 = { class: "agents light" }
const _hoisted_75 = { class: "wrap" }
const _hoisted_76 = { class: "h2 h2-md" }
const _hoisted_77 = { class: "pair" }
const _hoisted_78 = { class: "agent-kind" }
const _hoisted_79 = { class: "agent-kind" }
const _hoisted_80 = {
  id: "yours",
  class: "yours"
}
const _hoisted_81 = { class: "wrap" }
const _hoisted_82 = { class: "eyebrow ink" }
const _hoisted_83 = { class: "h2" }
const _hoisted_84 = { class: "lede-l" }
const _hoisted_85 = { class: "cfg" }
const _hoisted_86 = ["aria-label"]
const _hoisted_87 = ["aria-pressed", "onClick"]
const _hoisted_88 = { class: "preset-names" }
const _hoisted_89 = {
  class: "preview",
  "aria-live": "polite"
}
const _hoisted_90 = { class: "pcard" }
const _hoisted_91 = { class: "pcard" }
const _hoisted_92 = { class: "pcard" }
const _hoisted_93 = { class: "pchips" }
const _hoisted_94 = { class: "connect light" }
const _hoisted_95 = { class: "wrap two" }
const _hoisted_96 = { class: "eyebrow ink" }
const _hoisted_97 = { class: "h2 h2-md" }
const _hoisted_98 = { class: "lede-l" }
const _hoisted_99 = { class: "checks" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "✓", -1))
const _hoisted_101 = ["aria-label"]
const _hoisted_102 = { class: "wrap" }
const _hoisted_103 = { class: "eyebrow teal" }
const _hoisted_104 = { class: "h2" }
const _hoisted_105 = {
  key: 0,
  class: "quote"
}
const _hoisted_106 = { class: "fits light" }
const _hoisted_107 = { class: "wrap" }
const _hoisted_108 = { class: "eyebrow ink" }
const _hoisted_109 = { class: "h2 h2-md" }
const _hoisted_110 = ["aria-label"]
const _hoisted_111 = ["id", "aria-selected", "tabindex", "onClick"]
const _hoisted_112 = ["aria-labelledby"]
const _hoisted_113 = { class: "cta" }
const _hoisted_114 = { class: "wrap center" }
const _hoisted_115 = { class: "grad" }
const _hoisted_116 = { class: "cta-text" }

import {
  ref,
  computed,
  watch,
  nextTick,
  onMounted,
  onBeforeUnmount
} from "vue";
import ArrowRight from "../components/ArrowRight.vue";
import ConnecteraLogo from "../components/ConnecteraLogo.vue";
import { useLocalePath } from "../composables/useLocalePath";
import {
  gsap,
  ScrollTrigger,
  useMotion,
  useLoopPause,
  reveal,
  wordHighlight,
  words,
  motionAllowed
} from "../composables/useMotion";


export default /*#__PURE__*/_defineComponent({
  __name: 'Connectera',
  setup(__props) {

const lp = useLocalePath();

// Hero map
const entries = ["email", "chat", "forms", "console", "apps"];
const systems = ["crm", "erp", "billing", "docs"];
const entryPath = (i: number) => {
  const y = 73 + i * 58;
  return y === 189 ? "M180 189 H420" : `M180 ${y} C300 ${y} 330 190 420 190`;
};
const systemPath = (i: number) => {
  const y = 73 + i * 58;
  return y === 189 ? "M574 190 H820" : `M574 190 C660 190 680 ${y} 820 ${y}`;
};

// Story: colour is the actor (teal = the agent, amber = a person).
const stages = [
  { key: "request", kind: "req" },
  { key: "facts", kind: "ai" },
  { key: "rules", kind: "hand" },
  { key: "person", kind: "person" },
  { key: "close", kind: "ai" }
];
const colorOf: Record<string, string> = {
  req: "#E8F3FF",
  ai: "#34B1B9",
  hand: "#F0B25A",
  person: "#F0B25A"
};
// Without the scroll scene (phone, reduced motion, no JS) every stage is shown lit.
const stage = ref(stages.length - 1);
let storyTrigger: ScrollTrigger | undefined;
function goStage(i: number) {
  if (storyTrigger) {
    const y =
      storyTrigger.start +
      ((i + 0.5) / stages.length) * (storyTrigger.end - storyTrigger.start);
    window.scrollTo({ top: y, behavior: motionAllowed() ? "smooth" : "auto" });
  } else {
    stage.value = i;
  }
}

// Make it yours (fictional companies)
const presets = [
  { key: "lumen", color: "#2F6FDE" },
  { key: "atlas", color: "#C2410C" },
  { key: "verde", color: "#276749" }
];
const preset = ref(0);
const cur = computed(() => presets[preset.value]);

// Connect any system
const configLines: { t: string; c?: string }[][] = [
  [{ t: "tools = [{" }],
  [{ t: "  name    = " }, { t: '"billing"', c: "s" }],
  [{ t: "  openapi = " }, { t: '"billing-api.json"', c: "s" }],
  [{ t: "}]" }],
  [{ t: "operations = {" }],
  [
    { t: "  getContract = { agents = [" },
    { t: '"self_service"', c: "s" },
    { t: ", " },
    { t: '"assistant"', c: "s" },
    { t: "] }" }
  ],
  [{ t: "  issueRefund = {" }],
  [{ t: "    agents       = [" }, { t: '"assistant"', c: "s" }, { t: "]" }],
  [{ t: "    confirmation = true", c: "amber" }],
  [{ t: "  }" }],
  [{ t: "}" }]
];
const typed = ref(true);

const enterprise = [
  "account",
  "sso",
  "releases",
  "managed",
  "oversight",
  "traced"
];

// Where it fits: tabs with arrow-key navigation and a sliding pill.
const depts = [
  "service",
  "aftersales",
  "sales",
  "finance",
  "operations",
  "internal"
];
const dept = ref(0);
const tablist = ref<HTMLElement>();
const pillStyle = ref<Record<string, string>>({ opacity: "0" });
function placePill() {
  const btn = tablist.value?.querySelectorAll<HTMLElement>(".tab")[dept.value];
  if (!btn) return;
  pillStyle.value = {
    width: btn.offsetWidth + "px",
    height: btn.offsetHeight + "px",
    transform: `translate(${btn.offsetLeft}px, ${btn.offsetTop}px)`,
    opacity: "1"
  };
}
function onTabKey(e: KeyboardEvent) {
  const n = depts.length;
  if (e.key === "ArrowRight") dept.value = (dept.value + 1) % n;
  else if (e.key === "ArrowLeft") dept.value = (dept.value + n - 1) % n;
  else if (e.key === "Home") dept.value = 0;
  else if (e.key === "End") dept.value = n - 1;
  else return;
  e.preventDefault();
  nextTick(() =>
    tablist.value?.querySelectorAll<HTMLElement>(".tab")[dept.value]?.focus()
  );
}
watch(dept, () => nextTick(placePill));
onMounted(() => {
  placePill();
  document.fonts?.ready.then(placePill);
  window.addEventListener("resize", placePill);
});
onBeforeUnmount(() => window.removeEventListener("resize", placePill));

// Scroll scenes
const root = ref<HTMLElement>();
const hero = ref<HTMLElement>();
const heroText = ref<HTMLElement>();
const heroMap = ref<HTMLElement>();
const mapSvg = ref<SVGElement>();
const statement = ref<HTMLElement>();
const statementSection = ref<HTMLElement>();
const story = ref<HTMLElement>();
const events = ref<HTMLElement>();
const capGrid = ref<HTMLElement>();
const agentLeft = ref<HTMLElement>();
const agentRight = ref<HTMLElement>();
const code = ref<HTMLElement>();
const enterpriseEl = ref<HTMLElement>();
const entGrid = ref<HTMLElement>();
const ctaTitle = ref<HTMLElement>();

useLoopPause(mapSvg);

useMotion(root, ({ desktop }) => {
  // Hero: the map's paths draw in, then desktop pins for 100% while the map grows and the headline lifts.
  if (heroMap.value) {
    gsap.from(heroMap.value.querySelectorAll(".draw"), {
      opacity: 0,
      duration: 1.2,
      ease: "power2.out",
      stagger: 0.05,
      delay: 0.6
    });
  }
  if (desktop && hero.value && heroText.value && heroMap.value) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: hero.value,
          start: "top top+=116",
          end: "+=100%",
          scrub: 1,
          pin: true
        }
      })
      .to(heroText.value, { y: -60, opacity: 0, ease: "none" }, 0)
      .fromTo(
        heroMap.value,
        { scale: 0.9 },
        {
          scale: 1,
          y: () => -((heroText.value?.offsetHeight ?? 0) - 40),
          ease: "none"
        },
        0
      );
    // The map ends higher than it started: pull the next section up over the space it leaves.
    if (statementSection.value) {
      gsap.set(statementSection.value, {
        marginTop: () => -((heroText.value?.offsetHeight ?? 0) - 40),
        position: "relative",
        zIndex: 1
      });
    }
  }

  if (statement.value) wordHighlight(statement.value);

  // Story: desktop pins for 250% and the scroll position chooses the stage; phone reveals each event.
  if (desktop && story.value) {
    stage.value = 0;
    storyTrigger = ScrollTrigger.create({
      trigger: story.value,
      start: "top top+=116",
      end: "+=250%",
      pin: true,
      onUpdate: (self) =>
        (stage.value = Math.min(
          stages.length - 1,
          Math.floor(self.progress * stages.length)
        ))
    });
  } else if (events.value) {
    events.value
      .querySelectorAll(".event")
      .forEach((el) => reveal(el, el, { y: 16 }));
  }

  if (capGrid.value)
    reveal(capGrid.value.children, capGrid.value, {
      y: 24,
      scale: 0.96,
      stagger: 0.07
    });
  if (agentLeft.value)
    reveal(agentLeft.value, agentLeft.value, { x: -60, y: 0, duration: 0.7 });
  if (agentRight.value)
    reveal(agentRight.value, agentRight.value, { x: 60, y: 0, duration: 0.7 });

  // The configuration types itself, line by line at 14 ms per character; "confirmation = true" glows at the end.
  if (code.value) {
    typed.value = false;
    const tl = gsap.timeline({
      scrollTrigger: { trigger: code.value, start: "top 75%", once: true },
      onComplete: () => (typed.value = true)
    });
    code.value.querySelectorAll<HTMLElement>(".cline").forEach((line) => {
      const n = Math.max(1, (line.textContent ?? "").length);
      tl.fromTo(
        line,
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: n * 0.014,
          ease: `steps(${n})`
        }
      );
    });
  }

  if (enterpriseEl.value) {
    gsap.fromTo(
      enterpriseEl.value,
      { backgroundColor: "#F5F7F9", color: "#0B1726" },
      {
        backgroundColor: "#070D1A",
        color: "#E8F3FF",
        ease: "none",
        scrollTrigger: {
          trigger: enterpriseEl.value,
          start: "top 90%",
          end: "top 40%",
          scrub: true
        }
      }
    );
  }
  if (entGrid.value)
    reveal(entGrid.value.children, entGrid.value, { stagger: 0.06 });
  if (ctaTitle.value)
    reveal(ctaTitle.value, ctaTitle.value, { y: 40, duration: 0.8 });

  return () => {
    storyTrigger = undefined;
    stage.value = stages.length - 1;
    typed.value = true;
  };
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "cx"
  }, [
    _createElementVNode("nav", {
      class: "subnav",
      "aria-label": _ctx.$t('connectera.subnav.label')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createVNode(ConnecteraLogo)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("connectera.subnav.how")), 1),
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t("connectera.subnav.capabilities")), 1),
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("connectera.subnav.yours")), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("connectera.subnav.security")), 1)
        ]),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/contact'),
          class: "subnav-cta"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("connectera.subnav.demo")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("section", {
      id: "top",
      ref_key: "hero",
      ref: hero,
      class: "hero dark"
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          ref_key: "heroText",
          ref: heroText
        }, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("connectera.hero.eyebrow")), 1),
          _createElementVNode("h1", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(words)(_ctx.$t('connectera.hero.line1')), (w, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                _createElementVNode("span", {
                  class: "rise-word",
                  style: _normalizeStyle({ animationDelay: i * 0.07 + 's' })
                }, _toDisplayString(w), 5),
                _createTextVNode(_toDisplayString(" "))
              ], 64))
            }), 128)),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("connectera.hero.line2")), 1)
          ]),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("connectera.hero.lede")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/contact'),
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("connectera.hero.cta_primary")), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("a", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.$t("connectera.hero.cta_secondary")), 1),
              _createVNode(ArrowRight, { class: "down" })
            ])
          ])
        ], 512),
        _createElementVNode("figure", {
          ref_key: "heroMap",
          ref: heroMap,
          class: "map",
          "aria-label": _ctx.$t('connectera.hero.map_label')
        }, [
          (_openBlock(), _createElementBlock("svg", {
            ref_key: "mapSvg",
            ref: mapSvg,
            viewBox: "0 0 1000 400",
            width: "100%",
            "aria-hidden": "true"
          }, [
            _createElementVNode("g", _hoisted_18, [
              _createElementVNode("text", _hoisted_19, _toDisplayString(_ctx.$t("connectera.hero.m_entry")), 1),
              _createElementVNode("text", _hoisted_20, _toDisplayString(_ctx.$t("connectera.hero.m_agent_col")), 1),
              _createElementVNode("text", _hoisted_21, _toDisplayString(_ctx.$t("connectera.hero.m_systems")), 1)
            ]),
            _createElementVNode("g", _hoisted_22, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(entries, (k, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                  _createElementVNode("rect", {
                    x: "20",
                    y: 50 + i * 58,
                    width: "160",
                    height: "46",
                    rx: "12",
                    fill: "#142234"
                  }, null, 8, _hoisted_23),
                  _createElementVNode("text", {
                    x: "100",
                    y: 78 + i * 58,
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.$t(`connectera.hero.e_${k}`)), 9, _hoisted_24)
                ], 64))
              }), 64))
            ]),
            _createElementVNode("g", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(entries, (k, i) => {
                return _createElementVNode("path", {
                  key: k,
                  class: "flowline draw",
                  d: entryPath(i),
                  style: _normalizeStyle({ animationDelay: i * 0.2 + 's' })
                }, null, 12, _hoisted_26)
              }), 64))
            ]),
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("text", _hoisted_29, _toDisplayString(_ctx.$t("connectera.hero.m_agent")), 1),
            _createElementVNode("text", _hoisted_30, _toDisplayString(_ctx.$t("connectera.hero.m_agent_sub")), 1),
            _createElementVNode("g", _hoisted_31, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(systems, (k, i) => {
                return _createElementVNode("path", {
                  key: k,
                  class: "flowline draw",
                  d: systemPath(i),
                  style: _normalizeStyle({ animationDelay: 0.3 + i * 0.2 + 's' })
                }, null, 12, _hoisted_32)
              }), 64))
            ]),
            _createElementVNode("g", _hoisted_33, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(systems, (k, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                  _createElementVNode("rect", {
                    class: "lit",
                    x: "820",
                    y: 50 + i * 58,
                    width: "160",
                    height: "46",
                    rx: "12",
                    fill: "#0B2733",
                    stroke: "#34B1B9",
                    style: _normalizeStyle({ animationDelay: i * 0.6 + 's' })
                  }, null, 12, _hoisted_34),
                  _createElementVNode("text", {
                    x: "900",
                    y: 78 + i * 58,
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.$t(`connectera.hero.s_${k}`)), 9, _hoisted_35)
                ], 64))
              }), 64))
            ]),
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("text", _hoisted_38, _toDisplayString(_ctx.$t("connectera.hero.m_person")), 1),
            _createElementVNode("text", _hoisted_39, _toDisplayString(_ctx.$t("connectera.hero.m_person_sub")), 1)
          ], 512))
        ], 8, _hoisted_17),
        _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("connectera.hero.built_on")), 1)
      ])
    ], 512),
    _createElementVNode("section", {
      ref_key: "statementSection",
      ref: statementSection,
      class: "statement dark"
    }, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("p", {
          ref_key: "statement",
          ref: statement,
          class: "statement-text"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(words)(_ctx.$t('connectera.statement')), (w, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("span", _hoisted_42, _toDisplayString(w), 1),
              _createTextVNode(_toDisplayString(" "))
            ], 64))
          }), 128))
        ], 512)
      ])
    ], 512),
    _createElementVNode("section", {
      id: "story",
      ref_key: "story",
      ref: story,
      class: "story dark"
    }, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("connectera.story.eyebrow")), 1),
          _createElementVNode("h2", _hoisted_45, _toDisplayString(_ctx.$t("connectera.story.title")), 1),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("span", _hoisted_47, [
              _createElementVNode("span", {
                class: "stage-rail-fill",
                style: _normalizeStyle({
                  transform: `scaleY(${(stage.value + 1) / stages.length})`,
                  background: colorOf[stages[stage.value].kind]
                })
              }, null, 4)
            ]),
            _createElementVNode("ol", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stages, (s, i) => {
                return _createElementVNode("li", {
                  key: s.key
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(['stage-btn', { on: i === stage.value, past: i <= stage.value }]),
                    "aria-current": i === stage.value ? 'step' : undefined,
                    onClick: ($event: any) => (goStage(i))
                  }, [
                    _createElementVNode("span", _hoisted_49, "0" + _toDisplayString(i + 1), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t(`connectera.story.${s.key}.label`)), 1)
                  ], 10, _hoisted_48)
                ])
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "events",
          ref: events,
          class: "events"
        }, [
          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("connectera.story.case")), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stages, (s, i) => {
            return _createElementVNode("div", {
              key: s.key,
              class: _normalizeClass(['event', { dim: i > stage.value }])
            }, [
              _createElementVNode("span", {
                class: "event-dot",
                style: _normalizeStyle({
                background: colorOf[s.kind],
                boxShadow:
                  i === stage.value ? '0 0 0 4px rgba(52,177,185,0.25)' : 'none'
              })
              }, null, 4),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: "event-who",
                  style: _normalizeStyle({ color: colorOf[s.kind] })
                }, _toDisplayString(_ctx.$t(`connectera.story.${s.key}.who`)), 5),
                _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t(`connectera.story.${s.key}.text`)), 1),
                _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t(`connectera.story.${s.key}.sys`)), 1)
              ])
            ], 2)
          }), 64))
        ], 512)
      ])
    ], 512),
    _createElementVNode("section", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("connectera.caps.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_56, _toDisplayString(_ctx.$t("connectera.caps.title")), 1),
        _createElementVNode("div", {
          ref_key: "capGrid",
          ref: capGrid,
          class: "cap-grid"
        }, [
          _createElementVNode("article", _hoisted_57, [
            _createElementVNode("ul", _hoisted_58, [
              _hoisted_59,
              _hoisted_60,
              _hoisted_61,
              _createElementVNode("li", _hoisted_62, " issueRefund · " + _toDisplayString(_ctx.$t("connectera.caps.asks_first")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.caps.act.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.caps.act.text")), 1)
            ])
          ]),
          _createElementVNode("article", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createTextVNode(_toDisplayString(_ctx.$t("connectera.caps.playbook.v1")), 1),
              _hoisted_65,
              _createTextVNode("1. " + _toDisplayString(_ctx.$t("connectera.caps.playbook.v2")), 1),
              _hoisted_66,
              _createTextVNode("2. " + _toDisplayString(_ctx.$t("connectera.caps.playbook.v3")), 1),
              _hoisted_67,
              _createTextVNode("3. " + _toDisplayString(_ctx.$t("connectera.caps.playbook.v4")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.caps.playbook.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.caps.playbook.text")), 1)
            ])
          ]),
          _createElementVNode("article", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("connectera.caps.person.v")), 1),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.caps.person.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.caps.person.text")), 1)
            ])
          ]),
          _createElementVNode("article", _hoisted_70, [
            _createElementVNode("ul", _hoisted_71, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("connectera.caps.find.v1")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("connectera.caps.find.v2")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("connectera.caps.find.v3")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.caps.find.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.caps.find.text")), 1)
            ])
          ]),
          _createElementVNode("article", _hoisted_72, [
            _createElementVNode("ul", _hoisted_73, [
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("connectera.caps.prepare.v1")), 1),
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("connectera.caps.prepare.v1b")), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("connectera.caps.prepare.v2")), 1),
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("connectera.caps.prepare.v2b")), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("connectera.caps.prepare.v3")), 1),
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("connectera.caps.prepare.v3b")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.caps.prepare.title")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.caps.prepare.text")), 1)
            ])
          ])
        ], 512)
      ])
    ]),
    _createElementVNode("section", _hoisted_74, [
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("h2", _hoisted_76, _toDisplayString(_ctx.$t("connectera.agents.title")), 1),
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("article", {
            ref_key: "agentLeft",
            ref: agentLeft,
            class: "agent-card"
          }, [
            _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.$t("connectera.agents.self.kind")), 1),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.agents.self.title")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.agents.self.text")), 1)
          ], 512),
          _createElementVNode("article", {
            ref_key: "agentRight",
            ref: agentRight,
            class: "agent-card"
          }, [
            _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t("connectera.agents.assist.kind")), 1),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("connectera.agents.assist.title")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("connectera.agents.assist.text")), 1)
          ], 512)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.$t("connectera.yours.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_83, _toDisplayString(_ctx.$t("connectera.yours.title")), 1),
        _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$t("connectera.yours.lede")), 1),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "presets",
              role: "group",
              "aria-label": _ctx.$t('connectera.yours.pick')
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p, i) => {
                return _createElementVNode("button", {
                  key: p.key,
                  type: "button",
                  class: "preset",
                  "aria-pressed": i === preset.value ? 'true' : 'false',
                  style: _normalizeStyle({ borderColor: i === preset.value ? p.color : '#DCE3EA' }),
                  onClick: ($event: any) => (preset.value = i)
                }, [
                  _createElementVNode("span", {
                    class: "swatch",
                    style: _normalizeStyle({ background: p.color })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_88, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t(`connectera.yours.${p.key}.brand`)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`connectera.yours.${p.key}.sector`)), 1)
                  ])
                ], 12, _hoisted_87)
              }), 64))
            ], 8, _hoisted_86),
            _createVNode(_Transition, {
              name: "swap",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("dl", {
                  key: cur.value.key,
                  class: "facts"
                }, [
                  _createElementVNode("dt", null, _toDisplayString(_ctx.$t("connectera.yours.persona")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.persona`)), 1),
                  _createElementVNode("dt", null, _toDisplayString(_ctx.$t("connectera.yours.record")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.record`)), 1),
                  _createElementVNode("dt", null, _toDisplayString(_ctx.$t("connectera.yours.playbooks")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.playbooks`)), 1),
                  _createElementVNode("dt", null, _toDisplayString(_ctx.$t("connectera.yours.systems")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.systems`)), 1)
                ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", {
              class: "preview-head",
              style: _normalizeStyle({ background: cur.value.color })
            }, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.persona`)) + " · " + _toDisplayString(_ctx.$t("connectera.yours.assistant")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.brand`)), 1)
            ], 4),
            _createVNode(_Transition, {
              name: "swap",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  key: cur.value.key,
                  class: "preview-body"
                }, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t("connectera.yours.incoming")), 1),
                    _createTextVNode(" · " + _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.ask`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.panel`)), 1),
                  _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.answer`)), 1),
                  _createElementVNode("ul", _hoisted_93, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (c) => {
                      return _createElementVNode("li", {
                        key: c,
                        style: _normalizeStyle({
                      background: cur.value.color,
                      transitionDelay: c * 0.04 + 's'
                    })
                      }, _toDisplayString(_ctx.$t(`connectera.yours.${cur.value.key}.chips.c${c}`)), 5)
                    }), 64))
                  ])
                ]))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.$t("connectera.connect.eyebrow")), 1),
          _createElementVNode("h2", _hoisted_97, _toDisplayString(_ctx.$t("connectera.connect.title")), 1),
          _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.$t("connectera.connect.lede")), 1),
          _createElementVNode("ul", _hoisted_99, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['scoped', 'rules', 'trimmed'], (k) => {
              return _createElementVNode("li", { key: k }, [
                _hoisted_100,
                _createTextVNode(_toDisplayString(_ctx.$t(`connectera.connect.${k}`)), 1)
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("pre", {
          ref_key: "code",
          ref: code,
          class: _normalizeClass(['config', { glow: typed.value }]),
          "aria-label": _ctx.$t('connectera.connect.code_label')
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(configLines, (line, i) => {
            return _createElementVNode("span", {
              key: i,
              class: "cline"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (seg, j) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: j,
                  class: _normalizeClass(seg.c)
                }, _toDisplayString(seg.t), 3))
              }), 128))
            ])
          }), 64))
        ], 10, _hoisted_101)
      ])
    ]),
    _createElementVNode("section", {
      id: "security",
      ref_key: "enterpriseEl",
      ref: enterpriseEl,
      class: "enterprise"
    }, [
      _createElementVNode("div", _hoisted_102, [
        _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$t("connectera.enterprise.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_104, _toDisplayString(_ctx.$t("connectera.enterprise.title")), 1),
        _createElementVNode("div", {
          ref_key: "entGrid",
          ref: entGrid,
          class: "ent-grid"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(enterprise, (k) => {
            return _createElementVNode("article", {
              key: k,
              class: "ent"
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`connectera.enterprise.${k}.title`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`connectera.enterprise.${k}.text`)), 1)
            ])
          }), 64))
        ], 512),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/security'),
          class: "more"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("connectera.enterprise.more")), 1),
            _createVNode(ArrowRight)
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.$t('connectera.enterprise.quote'))
          ? (_openBlock(), _createElementBlock("blockquote", _hoisted_105, [
              _createTextVNode(_toDisplayString(_ctx.$t("connectera.enterprise.quote")) + " ", 1),
              _createElementVNode("cite", null, _toDisplayString(_ctx.$t("connectera.enterprise.quote_by")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createElementVNode("section", _hoisted_106, [
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.$t("connectera.fits.eyebrow")), 1),
        _createElementVNode("h2", _hoisted_109, _toDisplayString(_ctx.$t("connectera.fits.title")), 1),
        _createElementVNode("div", {
          ref_key: "tablist",
          ref: tablist,
          class: "tabs",
          role: "tablist",
          "aria-label": _ctx.$t('connectera.fits.eyebrow'),
          onKeydown: onTabKey
        }, [
          _createElementVNode("span", {
            class: "pill",
            "aria-hidden": "true",
            style: _normalizeStyle(pillStyle.value)
          }, null, 4),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(depts, (d, i) => {
            return _createElementVNode("button", {
              id: 'tab-' + d,
              key: d,
              type: "button",
              role: "tab",
              "aria-selected": i === dept.value ? 'true' : 'false',
              tabindex: i === dept.value ? 0 : -1,
              "aria-controls": "dept-panel",
              class: _normalizeClass(['tab', { on: i === dept.value }]),
              onClick: ($event: any) => (dept.value = i)
            }, _toDisplayString(_ctx.$t(`connectera.fits.${d}.area`)), 11, _hoisted_111)
          }), 64))
        ], 40, _hoisted_110),
        _createVNode(_Transition, {
          name: "swap",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              id: "dept-panel",
              key: dept.value,
              role: "tabpanel",
              "aria-labelledby": 'tab-' + depts[dept.value],
              class: "tabpanel"
            }, _toDisplayString(_ctx.$t(`connectera.fits.${depts[dept.value]}.work`)), 9, _hoisted_112))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_113, [
      _createElementVNode("div", _hoisted_114, [
        _createElementVNode("h2", {
          ref_key: "ctaTitle",
          ref: ctaTitle,
          class: "cta-title"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("connectera.cta.title_a")) + " ", 1),
          _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.$t("connectera.cta.title_b")), 1)
        ], 512),
        _createElementVNode("p", _hoisted_116, _toDisplayString(_ctx.$t("connectera.cta.text")), 1),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/contact'),
          class: "btn btn-primary btn-lg"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("connectera.cta.button")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 512))
}
}

})